<template>
  <div>
    <q-dialog
      :visible="isVisible"
      :title="title"
      width="700px"
      :innerScroll="false"
      @close="onCancel"
      :showFooter="false"
    >
      <div class="content">
        <el-table :data="tableData.records" border :height="300" style="width: 100%" v-loading="loading">
          <el-table-column
            :label="item.label"
            :prop="item.prop"
            :fixed="item.fixed"
            :min-width="item.width"
            show-overflow-tooltip
            v-for="item in columnData"
            :key="item.prop"
            :align="item.children ? 'center' : 'left'"
          >
            <template slot-scope="scope">
              {{ scope.row[item.prop] }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </q-dialog>
  </div>
</template>

<script>
export default {
  name: "storeClearance",
  components: {},
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    modifyData: Object,
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    title() {
      return '全网清仓情况';
    },
  },
  data() {
    return {
      loading: false,
      addForm: {},
      columnData: [],
      tableData: {
        records: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      }
    };
  },
  methods: {
    init() {
      this.loading = true
      let data = {
        ...this.modifyData
      }
      this.$q.clearanceManagement.allGoodsSaleInfo({data: data}).then(res => {
        if(res.data && res.data.dynamicData) {
          this.tableData = res.data.dynamicData
          this.columnData = res.data.titleList.map(v => {
            return {
              label: v.titleName,
              prop: v.propertyName,
              width: v.displayWidth,
              sortable: false,
              span: false,
              fixed: false,
            }
          })
        } else {
          this.tableData.records = []
        }
      }).finally(() => {
        this.loading = false
      });
    },
    onCancel() {
      this.isVisible = false;
    },
  },
  created() {
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
.content {
  max-height: 60vh;
  overflow-y: auto;
}

.form-input {
  width: 200px;
}

.input-number {
  >>> .el-input__inner {
    text-align: left;
  }
}

>>> .el-form .el-form-item {
  margin-bottom: 22px;
}
</style>